import { IMessage } from "@/models";
import { RuleDecl } from "vue/types/options";
import { maxLength, minLength, required, requiredIf } from "vuelidate/lib/validators";

const VALIDATION_LIMITS = {
    MIN_LENGTH: 4,
    MAX_LENGTH: 3000
} as const;

export const validations: RuleDecl = {
    decisionDescription: {
        requiredDescription: required,
        descriptionMinLength: minLength(VALIDATION_LIMITS.MIN_LENGTH),
        descriptionMaxLength: maxLength(VALIDATION_LIMITS.MAX_LENGTH),
    },
    newMessage: {
        text: {
            requiredMessage: requiredIf(isTextRequired),
            newMessageMinLength: cleanTextAndCheckMinLength,
            newMessageMaxLength: maxLength(VALIDATION_LIMITS.MAX_LENGTH),
        },
    },
    editedMessage: {
        text: {
            requiredMessage: requiredIf(isTextRequired),
            newMessageMinLength: cleanTextAndCheckMinLength,
            newMessageMaxLength: maxLength(VALIDATION_LIMITS.MAX_LENGTH),
        },
    },
    finalStatus: {
        required,
    },
};

function isTextRequired(value: IMessage): boolean {
    return !!value?.issue;
}

function cleanTextAndCheckMinLength(value: string, parent: { issue: boolean }): boolean {
    // Regex to remove p and br tags (added when text is empty)
    const text = value?.replace(/<\/?p>|<br\s*\/?>/g, '') ?? "";
    return !parent.issue || text.length >= VALIDATION_LIMITS.MIN_LENGTH;
}

export const validationMessages = {
    requiredDescription: "Description is required",
    descriptionMinLength: `Description must have at least ${VALIDATION_LIMITS.MIN_LENGTH} letters`,
    descriptionMaxLength: `Description must have less than ${VALIDATION_LIMITS.MAX_LENGTH} letters`,
    requiredMessage: "Message is required",
    newMessageMinLength: `Message must have at least ${VALIDATION_LIMITS.MIN_LENGTH} letters`,
    newMessageMaxLength: `Message must have less than ${VALIDATION_LIMITS.MAX_LENGTH} letters`,
};
